import { useMemo, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import {
  Card,
  CardContent,
  Divider,
  Typography,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import TimeFilter from "../common/TimeFilter";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const scores = [
  0, 0, 42423, 0, 0, 0,
];
const labels = ["00:00-04:00", "04:01-08:00", "08:01-12:00", "12:01-16:00", "16:01-20:00", "20:01-23:59"];

const options = {
  fill: true,
  responsive: true,
  scales: {
    y: {
      min: 0,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

export default function AmountPerPeriodHours() {
  const { t } = useTranslation();

  const theme = useTheme();

  const data = useMemo(function () {
    return {
      datasets: [
        {
          label: "Monto",
          data: scores,
          tension: 0.4,
          borderColor: theme.palette.primary.light,
          pointRadius: 4,
          pointBackgroundColor: theme.palette.primary.main,
          backgroundColor: "transparent",
        },
      ],
      labels,
    };
  }, []);

  return (
    <Card elevation={5} sx={{ borderRadius: "20px", minWidth: {sm: "50%", md: "100%"} }}>
      <CardContent>
        <Stack direction="column" spacing={2} alignItems="baseline">
          <Typography variant="h6">{t("amountcardHours.title")}</Typography>
          {/* <Typography variant="p">{t("amountcardHours.subtitle")}</Typography> */}
        </Stack>
        <Divider sx={{ my: "1rem" }} />
        <Typography>Total</Typography>
        <Stack direction="row" spacing={1} alignItems="top" mb={2}>
          <Typography variant="h5" fontWeight={600}>$42.423</Typography>
          <Typography variant="p">COP</Typography>
        </Stack>
        <Line data={data} options={options} />
      </CardContent>
    </Card>
  );
}
